import { useApiSegmentsRange } from '@app/core/hooks/api/useApiSegmentsRange';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { TimeRange } from '@mi-front/core';

/**
 * Fetches the segments used to align thumbnails within the stream range.
 */
export function useThumbnailsStreamSegments(range: TimeRange<number>) {
  const activeStation = useActiveStation();

  const query = useApiSegmentsRange(activeStation.id, range.from, range.to, {
    enabled: !!range.from,
  });

  return {
    segments: query.data ?? [],
    isLoading: query.isLoading,
  };
}
